<template>
  <div class="dialog-reset-pwd">
    <Form :model="pwdData" :label-width="100" ref="resetPwdForm" :rules="validateRules">
      <FormItem label="原密码：" prop="oldPwd" v-if="fromSource!=='user'">
        <Input type="password" v-model="pwdData.oldPwd" :autofocus="true" placeholder="请输入原密码"></Input>
      </FormItem>
      <FormItem label="新密码：" prop="newPwd">
        <Input :type="fromSource==='user'?'text':'password'" v-model="pwdData.newPwd" placeholder="请输入新密码"></Input>
      </FormItem>
      <FormItem label="确认密码：" prop="confirmPwd" v-if="fromSource!=='user'">
        <Input type="password" v-model="pwdData.confirmPwd" placeholder="请再次输入新密码"></Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: 'resetPwd',
  props: {
    query: ''
  },
  data () {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.pwdData.newPwd !== '' && value === '') {
        callback(new Error('确认密码不能为空'));
      } else if (this.pwdData.newPwd !== value) {
        callback(new Error('两次输入密码的不一致，请重新输入'));
      } else {
        callback();
      }
    }
    return {
      userId: '',
      fromSource: '',
      pwdData: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      validateRules: {
        oldPwd: [{required: true, message: '原密码不能为空', trigger: 'blur'}],
        newPwd: [{required: true, message: '新密码不能为空', trigger: 'blur'}],
        confirmPwd: [{required: true, validator: pwdCheckValidate, trigger: 'blur'}]
      }
    }
  },
  created () {
    if (this.query) {
      this.userId = this.query.split('&')[0];
      this.fromSource = this.query.split('&')[1];
    }
  },
  methods: {
    // 确定回调事件
    dialogComfirm () {
      return new Promise((resolve, reject) => {
        const _self = this;
        _self.$refs['resetPwdForm'].validate((valid) => {
          if (valid) {
            if (_self.fromSource === 'user') {
              _self.post('/sys/user/resetPasswordByAdmin', {
                newPassword: _self.pwdData.newPwd,
                userId: _self.userId
              }).then(res => {
                _self.$Message.success(res.msg);
                resolve(res);
              }).catch(error => {
                reject(error);
              });
            } else {
              _self.post('/sys/user/password', {
                newPassword: _self.pwdData.newPwd,
                password: _self.pwdData.oldPwd
              }).then(res => {
                resolve(res);
              }).catch(error => {
                reject(error);
              });
            }
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/resetPwd.vue